function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".supporta{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2118.406 -9898.607)"
}, /*#__PURE__*/React.createElement("path", {
  className: "supporta",
  d: "M2146.6,9915.171a.785.785,0,0,1-.786-.785v-8.616a5.59,5.59,0,0,0-11.18,0v8.616a.786.786,0,0,1-1.572,0v-8.616a7.161,7.161,0,1,1,14.323,0v8.616A.785.785,0,0,1,2146.6,9915.171Z",
  transform: "translate(-10.818)"
}), /*#__PURE__*/React.createElement("path", {
  className: "supporta",
  d: "M2153.135,9965.752a2.42,2.42,0,1,1,2.42-2.42A2.423,2.423,0,0,1,2153.135,9965.752Zm0-3.269a.849.849,0,1,0,.848.849A.85.85,0,0,0,2153.135,9962.483Z",
  transform: "translate(-23.847 -45.987)"
}), /*#__PURE__*/React.createElement("path", {
  className: "supporta",
  d: "M2123.03,9934.687h-1.6a3.028,3.028,0,0,1-3.024-3.024v-3.591a3.027,3.027,0,0,1,3.024-3.023h1.6a.786.786,0,1,1,0,1.571h-1.6a1.454,1.454,0,0,0-1.452,1.452v3.591a1.455,1.455,0,0,0,1.452,1.453h1.6a.786.786,0,1,1,0,1.571Z",
  transform: "translate(0 -19.516)"
}), /*#__PURE__*/React.createElement("path", {
  className: "supporta",
  d: "M2184.136,9934.687h-1.6a.786.786,0,1,1,0-1.571h1.6a1.455,1.455,0,0,0,1.452-1.453v-3.591a1.454,1.454,0,0,0-1.452-1.452h-1.6a.786.786,0,1,1,0-1.571h1.6a3.027,3.027,0,0,1,3.024,3.023v3.591A3.027,3.027,0,0,1,2184.136,9934.687Z",
  transform: "translate(-46.754 -19.516)"
}), /*#__PURE__*/React.createElement("path", {
  className: "supporta",
  d: "M2166.6,9960.381h-2.623a.785.785,0,1,1,0-1.57h2.623a1.455,1.455,0,0,0,1.452-1.453v-.722a.786.786,0,1,1,1.571,0v.722A3.027,3.027,0,0,1,2166.6,9960.381Z",
  transform: "translate(-33.056 -42.25)"
}));

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21.158,
    viewBox: "0 0 22 21.158",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.cc337ce3.svg";
export { ForwardRef as ReactComponent };